const listeners = new Set();

/**
 * Inventory can change outside this browser when an approved job feed performs
 * its first pull. The Settings and Listings routes share cached facilities and
 * listings, so both data providers subscribe to this one invalidation signal.
 */
export const subscribeToCompanyInventoryChanges = (listener) => {
  if (typeof listener !== 'function') return () => {};
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const notifyCompanyInventoryChanged = (detail = {}) => {
  for (const listener of listeners) {
    try {
      listener(detail);
    } catch {
      // A stale page-level reader must not prevent the approval redirect.
    }
  }
};

